import React from 'react';
import PropTypes from 'prop-types';

import PlaylistMenu from '../../../left-bar/PlaylistMenu';
import Spinner from '../../../common/Spinner';

function CustomPlaylists({ list }) {
  return (
    <>
      { list.map( (p, i) => {
        return (p.load)
          ? <Spinner key={`load-playlist-${i}`} style={{ position: 'relative', marginBottom: 20, marginLeft: 16 }} />
          : <PlaylistMenu key={p.id} index={i} playlist={p} name={p.name} track_count={p.track_count} length_ms={p.length_ms} draggable={false} />
      })}
    </>
  )
}

CustomPlaylists.propTypes = {
  list: PropTypes.any
}

export default CustomPlaylists;
